
import { useState } from 'react';
import { ShieldCheck, CircleHelp } from 'lucide-react';
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogClose
} from "@/components/ui/dialog";
import { Button } from '@/components/ui/button';

export const AdminHeader: React.FC = () => {
  const [helpOpen, setHelpOpen] = useState(false);

  const helpContent = {
    title: "Admin Dashboard Help",
    description: "Manage your BJJ technique library",
    content: (
      <>
        <p>Welcome to the Admin Dashboard! Here you can:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Browse and search official techniques in the library</li>
          <li>Edit technique details, media, and attributes</li>
          <li>Create new official techniques for your users</li>
          <li>Manage visibility and publish status of techniques</li>
          <li>Monitor policy compliance across the application</li>
          <li>Enforce standardized admin access checks</li>
        </ul>
        <p>Use the table below to easily manage all your technique content.</p>
      </>
    )
  };

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-display font-bold inline-flex items-center gap-2">
          Admin Dashboard
          <CircleHelp 
            className="h-5 w-5 text-primary cursor-pointer hover:text-primary/80 transition-colors" 
            onClick={() => setHelpOpen(true)}
            strokeWidth={2} 
          />
        </h1>
      </div>
      <p className="text-muted-foreground">
        Manage technique media, content, and system settings in a spreadsheet-like interface
      </p>

      {/* Help Dialog */}
      <Dialog open={helpOpen} onOpenChange={setHelpOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{helpContent.title}</DialogTitle>
            <DialogDescription>
              {helpContent.description}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {helpContent.content}
          </div>
          <div className="flex justify-end">
            <DialogClose asChild>
              <Button variant="default" size="sm">Got it</Button>
            </DialogClose>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
